/* Lou's Redesign 2026 - Startseite: Slider (New In, Bewertungen), "Mehr lesen", FAQ-Akkordeon.
   Per Event-Delegation, damit es auch nach einem Neuladen der Section im Theme-Editor funktioniert. */
(function () {
  if (window.__lrHome) return;
  window.__lrHome = true;

  function step(track, dir) {
    var first = track.firstElementChild;
    var gap = parseInt(getComputedStyle(track).columnGap || getComputedStyle(track).gap, 10) || 16;
    track.scrollBy({ left: dir * (first ? first.offsetWidth + gap : track.clientWidth), behavior: 'smooth' });
  }

  function trackFor(btn) {
    var root = btn.closest('[data-lrh-slider]');
    return root ? root.querySelector('[data-lrh-track]') : null;
  }

  function updateSlider(root) {
    var track = root.querySelector('[data-lrh-track]');
    if (!track) return;
    var max = track.scrollWidth - track.clientWidth;
    var prev = root.querySelector('[data-lrh-prev]');
    var next = root.querySelector('[data-lrh-next]');
    if (prev) prev.disabled = track.scrollLeft <= 2;
    if (next) next.disabled = track.scrollLeft >= max - 2;
    var prog = root.querySelector('[data-lrh-prog]');
    if (prog) {
      var w = track.scrollWidth > 0 ? Math.min(100, (track.clientWidth / track.scrollWidth) * 100) : 100;
      var left = max > 0 ? (track.scrollLeft / max) * (100 - w) : 0;
      prog.style.setProperty('--p-w', w + '%');
      prog.style.setProperty('--p-left', left + '%');
    }
  }

  function updateMore(root) {
    root.querySelectorAll('.lrh-tp-card').forEach(function (card) {
      var text = card.querySelector('[data-lrh-text]');
      var btn = card.querySelector('[data-lrh-more]');
      if (!text || !btn) return;
      if (text.classList.contains('is-clamped')) btn.hidden = text.scrollHeight <= text.clientHeight + 1;
    });
  }

  function updateAll() {
    document.querySelectorAll('[data-lrh-slider]').forEach(function (r) { updateSlider(r); updateMore(r); });
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t.closest) return;
    var prev = t.closest('[data-lrh-prev]');
    var next = t.closest('[data-lrh-next]');
    if (prev || next) {
      var track = trackFor(prev || next);
      if (track) step(track, prev ? -1 : 1);
      return;
    }
    var more = t.closest('[data-lrh-more]');
    if (more) {
      var text = more.parentElement.querySelector('[data-lrh-text]');
      var open = text.classList.toggle('is-clamped') === false;
      more.textContent = open ? more.getAttribute('data-less') : more.getAttribute('data-more');
      more.setAttribute('aria-expanded', open ? 'true' : 'false');
      return;
    }
    var q = t.closest('[data-lrh-q]');
    if (q) {
      var group = q.closest('[data-lrh-faq]');
      var willOpen = q.getAttribute('aria-expanded') !== 'true';
      if (group) {
        group.querySelectorAll('[data-lrh-q]').forEach(function (b) {
          b.setAttribute('aria-expanded', 'false');
          var body = document.getElementById(b.getAttribute('aria-controls'));
          if (body) body.hidden = true;
        });
      }
      q.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
      var panel = document.getElementById(q.getAttribute('aria-controls'));
      if (panel) panel.hidden = !willOpen;
    }
  });

  document.addEventListener('scroll', function (e) {
    var el = e.target;
    if (el && el.hasAttribute && el.hasAttribute('data-lrh-track')) {
      var root = el.closest('[data-lrh-slider]');
      if (root) updateSlider(root);
    }
  }, true);

  var timer;
  window.addEventListener('resize', function () { clearTimeout(timer); timer = setTimeout(updateAll, 150); });
  window.addEventListener('load', updateAll);
  document.addEventListener('shopify:section:load', updateAll);
  if (document.readyState !== 'loading') updateAll(); else document.addEventListener('DOMContentLoaded', updateAll);
})();
